var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marker",style:(_vm.position),on:{"click":function($event){return _vm.$emit('marker-click', _vm.markerId)}}},[_c('img',{staticClass:"gray",attrs:{"src":require("../assets/circle-icon.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }